import React from 'react';

const PendingStepIcon = ({ className = "text-muted me-2", ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="img" {...props}>
        <title>Pendiente</title>
        <circle cx="8" cy="8" r="7" />
    </svg>
);

export default PendingStepIcon;